
import "./style.css";
import React, {useState, useEffect} from 'react';
import { Grid, Typography, Button, Box, Card, CardContent, CardActions, Checkbox, Select, MenuItem, FormControlLabel, Switch } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
import axios from "axios";
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import {read} from "../../../pages/Kontrak/API/Step1/apispecific.js";
import {readComp} from "../../../pages/Kontrak/API/Step1/apicompspecific.js";


const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="Rp."
    />
  );
});
const Step4 = (props) => {
  const [focus, setFocus] = useState();

  const handleSebelumPPN = (event) => {
    if(focus==="sebelumPPN"){
    setkontrakSub(event.target.value)
    setkontrakGrand(Math.floor(event.target.value*(1+(ppnPercent/100))))
    setDiscPercent(Math.floor((nominalDisc/event.target.value)*10000)/100);
    setSubDiskon(Math.floor((event.target.value-nominalDisc)*100)/100);
    setGrandDiskon(Math.floor((event.target.value-nominalDisc)*(1+(parseInt(ppnPercent)/100))*100)/100);
  }
  }
const handleSetelahPPN = (event) => {
  if(focus==="setelahPPN"){
  setkontrakGrand(event.target.value)
  setkontrakSub(Math.floor(event.target.value*(1-(ppnPercent/100))))
  
  setDiscPercent(Math.floor((nominalDisc/(Math.floor(event.target.value*(1-(ppnPercent/100)))))*10000)/100);
  setSubDiskon(Math.floor(((Math.floor(event.target.value*(1-(ppnPercent/100))))-nominalDisc)*100)/100);
  setGrandDiskon(Math.floor(((Math.floor(event.target.value*(1-(ppnPercent/100))))-nominalDisc)*(1+(parseInt(ppnPercent)/100))*100)/100);
  }
}

  const [hargaDiskon, sethargaDiskon] = useState();
  const [categorias, setCategorias] = useState([]);
  const midnightToday = new Date();
  midnightToday.setHours(7, 0, 0, 0);
  const [paidDate, setpaidDate] = useState(midnightToday);
  const [alamatKontrak, setalamatKontrak] = useState(null);
  const [address2, setAddress2] = useState();
  const [address3, setAddress3] = useState();
  const [phone, setPhone] = useState();
  const [lokasiSingkatan,setLokasiSingkatan] = useState();
  const handleChangeAddress = (event) => {
    setalamatKontrak(event.target.value)
    const alamatDicari = event.target.value
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/confirm-address`,{
            alamatDicari
    }).then(response=>{
        console.log(response.data)
        setAddress2(response.data.address2)
        setAddress3(response.data.address3)
        setPhone(response.data.phone)
        setLokasiSingkatan(response.data.LokasiSingkatan)
    });
};
    const handleDateChange = (date) => {
        setpaidDate(date);
        const piDate = date.getDate();
        const longMonth = date.toLocaleString('default', { month: 'long' });
        const piYear = date.getFullYear();
        console.log(piDate + " " + longMonth + " " + piYear);
    }
    const shout = () => {

    }
    const [selectedPackage, setSelectedPackage] = useState(null);
    const getSelectedPackageTitle = () => {
        switch (selectedPackage) {
          case 0:
            return 'Virtual Office';
          case 1:
            return 'Private Office';
          // Add more cases for other package indices
          default:
            return '';
        }
      };

      const getTanggalAkhir = () => {
        let newDate;
    
        if (unitDurasiKontrak === "Tahun") {
            // Add the years and subtract one day
            newDate = new Date(paidDate.getFullYear() + parseInt(durasiKontrak), paidDate.getMonth(), paidDate.getDate());
        } else {
            // Handle the month addition
            newDate = new Date(paidDate.getFullYear(), paidDate.getMonth() + parseInt(durasiKontrak), paidDate.getDate());
        }
    
        // Subtract one day, considering the month/year roll-over
        newDate.setDate(newDate.getDate() - 1);
    
        // Set the time to 00:00:00
        newDate.setHours(7, 0, 0, 0);

        return newDate;
    }
    const [searchThis, setsearchThis] = useState();
    const searchSelected = () => {

    } 

    
    const getCategorias = async () => {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
      }).then(response=>{
        setCategorias(response.data.pilihanAlamat);
    });
      //console.log(res);
    }
    useEffect(() => {
        getCategorias();})
    
const [durasiKontrak, setdurasiKontrak] = useState(1);
const [unitDurasiKontrak, setunitDurasiKontrak] = useState("Tahun");
const [kontrakSub, setkontrakSub] = useState();
const [discStatus, setDiscStatus] = useState("No")
const [kontrakPPN, setkontrakPPN] = useState();
const [kontrakGrand, setkontrakGrand] = useState();
const [diskon, setDiskon] = useState();
const [tipeCall, setTipeCall] = useState();
const [ppnPercent,setppnPercent] = useState(parseInt("11%"));
const handleppnPercent = (event) => {
  if(focus==="PPN"){

  setppnPercent(parseInt(event.target.value));
  setkontrakGrand(Math.floor(kontrakSub*(1+(parseInt(event.target.value)/100))))
  
  setDiscPercent(Math.floor((nominalDisc/kontrakSub)*10000)/100);
    setSubDiskon(Math.floor((kontrakSub-nominalDisc)*100)/100);
    setGrandDiskon(Math.floor(((kontrakSub-nominalDisc)*(1+(parseInt(event.target.value)/100)))*10)/10);
  
  }
}
const [nominalDisc, setNominalDisc] = useState();
const handleNominalDisc = (event) => {
  if(focus ==="nominalDisc"){
    console.log("here")
    setNominalDisc(event.target.value)
    setDiscPercent(Math.floor((event.target.value/kontrakSub)*10000)/100);
    setSubDiskon(Math.floor((kontrakSub-event.target.value)*100)/100);
    setGrandDiskon(Math.floor((kontrakSub-event.target.value)*(1+(parseInt(ppnPercent)/100))*100)/100);
  }

}

const [DiscPercent, setDiscPercent] = useState();

const handleDiscPercent = (event) => {
  if(focus ==="DiscPercent"){
    setDiscPercent(event.target.value);
    setNominalDisc((parseInt(event.target.value)/100)*kontrakSub);
    setSubDiskon(Math.floor(kontrakSub-((parseInt(event.target.value)/100)*kontrakSub)*100)/100);
    setGrandDiskon(Math.floor((kontrakSub-((parseInt(event.target.value)/100)*kontrakSub))*(1+(parseInt(ppnPercent)/100))*100)/100);
  }
}

const [subDiskon, setSubDiskon] = useState();
const handleSubDiskon = (event) => {
  if(focus === "subDiskon"){

  setSubDiskon(event.target.value)
  setNominalDisc(kontrakSub-event.target.value)
  setDiscPercent(Math.floor(((kontrakSub-event.target.value)/kontrakSub)*10000)/100);
  setGrandDiskon(Math.floor(event.target.value*(1+(parseInt(ppnPercent)/100))*100)/100);
}
}

const [grandDiskon, setGrandDiskon] = useState();
const handleGrandDiskon = (event) => {
  if(focus === "grandDiskon"){
    setGrandDiskon(event.target.value)
    setSubDiskon(Math.floor(event.target.value/(1+(parseInt(ppnPercent)/100))*100)/100)
    setDiscPercent(Math.floor(((kontrakSub-(event.target.value/(1+(parseInt(ppnPercent)/100))))/kontrakSub)*10000)/100);
    setNominalDisc(Math.floor((kontrakSub-(event.target.value/(1+(parseInt(ppnPercent)/100))))))

  }
}
const [unitMeetingKontrak, setunitMeetingKontrak] = useState("jam /Tahun");
const [selectedPaketVO, setselectedPaketVO] = useState();
const [state, setState] = useState({
  gilad: false,
  jason: false,
  antoine: true,
});
const switchChange = (event) => {
  setState({
    ...state,
    [event.target.name]: event.target.checked,
  });
  if(discStatus === "No"){
    setDiscStatus("Yes")
  }else{
    setDiscStatus("No")
    setNominalDisc();
    setDiscPercent();
    setSubDiskon();
    setGrandDiskon();
  }
}

const getClient = async() => {
  const { data, error } = await read(props.klienID);
  console.log(props.klienID)
  console.log("the following is the data")
  console.log(data[0])
  return data
}

const getCompany = async() => {
  const { data, error } = await readComp(props.companyID);
  console.log(props.companyID)
  console.log("the following is the data")
  console.log(data[0])
  return data
}

const [durasiMeetingKontrak, setdurasiMeetingKontrak] = useState(0);
    const handlePackageClick = (index) => {
        setSelectedPackage(index);
      };
    if (props.currentStep !== 4 || props.selectedPost.packageTitle !== "Virtual Office") {
        return null;
      }
      
      const renderPackageCard = (index, title, disabled = false) => (
        <Card
          onClick={disabled ? null : () => handlePackageClick(index)}
          sx={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            borderColor: selectedPackage === index ? 'primary.main' : 'divider',
            borderWidth: 1,
            borderStyle: 'solid',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: disabled ? 'action.disabledBackground' : 'background.paper',
            opacity: disabled ? 0.5 : 1,
          }}
        >
          <CardContent>
            <Typography variant="h5">{title}</Typography>
          </CardContent>
          {selectedPackage === index && !disabled && (
            <CardActions>
              <CheckCircleOutlineIcon color="primary" />
            </CardActions>
          )}
        </Card>
      );
    return (<Grid container>
                
                
                            <Grid container className="verticalAlign">
                                
                            </Grid>
                            <Grid container className="verticalAlign">
                                
                            </Grid>
                            <Grid container className="verticalAlign">
                                
                            </Grid>
                            <Grid container className="verticalAlign">
                                
                            </Grid>
                            <Grid>
                              <Button onClick={()=>shout()}>Preview PI</Button>
                            </Grid>
                            <Grid container>
                            
                              <Grid item xs={5}><Typography variant="h6">Tanggal Mulai Kontrak:</Typography></Grid>
                              <Grid item xs={7}>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={paidDate}
                                    onChange={handleDateChange}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                    </LocalizationProvider>

                              </Grid>
                            </Grid>
                            <Grid container sx={{mt:2}}>
                              <Grid item xs={5}><Typography variant="h6">Durasi Kontrak:</Typography></Grid>
                              <TextField value={durasiKontrak} type="number" onChange={event=> setdurasiKontrak(event.target.value)}></TextField>
                              <Select value={unitDurasiKontrak} onChange={event => setunitDurasiKontrak(event.target.value)}><MenuItem value="Hari">Hari</MenuItem><MenuItem value="Bulan">Bulan</MenuItem><MenuItem value="Tahun">Tahun</MenuItem></Select>
                            </Grid>
                            <Grid container sx={{mt:2}}>
                              <Grid item xs={5}><Typography variant="h6">Lokasi Kontrak:</Typography></Grid>
                              <Select value={alamatKontrak} whiteSpace="normal" onChange={event => handleChangeAddress(event)}>{categorias.map((categoria) =><MenuItem multiline value={categoria}>{categoria}</MenuItem>)}</Select>                            </Grid>
                            <Grid container sx={{mt:2}}>
                              <Grid item xs={5}><Typography variant="h6">Nama Paket Virtual Office</Typography></Grid>
                              <Select value={selectedPaketVO} onChange={event => setselectedPaketVO(event)}><MenuItem value="Plain Package">Plain Package</MenuItem><MenuItem value="Public Package">Public Package</MenuItem><MenuItem value="Premium Package">Premium Package</MenuItem><MenuItem value="Prestige Package">Prestige Package</MenuItem></Select>
                            </Grid>
                            <Grid container sx={{mt:2}}>                              
                                
                            <Grid item xs={5} sx={{mt:2}}><Typography variant="h6"> Meeting Room:</Typography></Grid>
                                <TextField value={durasiMeetingKontrak} type="number" onChange={event=> setdurasiMeetingKontrak(event.target.value)}></TextField>
                                <Select value={unitMeetingKontrak} onChange={event => setunitMeetingKontrak(event.target.value)}><MenuItem value="jam /Bulan">jam /Bulan</MenuItem><MenuItem value="jam /Tahun">jam /Tahun</MenuItem></Select>
                            </Grid>

                            <Grid container sx={{mt:10}}>
                              <Grid item xs={7}><Typography variant="h6">Biaya Sebelum PPN:</Typography></Grid>
                              <Grid item xs={5}><TextField
                                name="Sebelum PPN"
                                placeholder="Sebelum PPN"
                                value={kontrakSub}
                                onFocus={event => setFocus("sebelumPPN")}
                                onChange={event => handleSebelumPPN(event)}
                                InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}}
                                
                            /></Grid>
                              
                            </Grid>
                            <Grid container>
                              <Grid item xs={7}><Typography variant="h6">PPN:</Typography></Grid>
                              <Grid item xs={5}><NumberFormat customInput={TextField} 
                                variant="outlined"
                                thousandSeparator={true}
                                suffix={'%'}
                                value={ppnPercent}
                                onChange={event => handleppnPercent(event)}
                                onFocus={event => setFocus("PPN")}
                                autoComplete="off"/></Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={7}><Typography variant="h6">Grand Total</Typography></Grid>
                              <Grid item xs={5}><TextField
                                name="Setelah PPN"
                                placeholder="Setelah PPN"
                                value={kontrakGrand}
                                onChange={event => handleSetelahPPN(event)}
                                onFocus={event => setFocus("setelahPPN")}
                                InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}}
                                
                            /></Grid>
                            </Grid>
                            <Grid container sx={{mt:5}}>
                            <Grid xs={7}><Typography variant="h6">Apakah ada Diskon?</Typography></Grid>
                            <FormControlLabel control={<Switch checked={state.gilad} onChange={switchChange} name="gilad"/>} label={discStatus} />

                            </Grid>
                            {discStatus === "Yes" && (

                            <Grid container sx={{mt:5}}>
                              <Grid item xs={7}><Typography variant="h6">Discount:</Typography></Grid>
                              <Grid item xs={3}><TextField
                                name="Net Setelah Diskon"
                                placeholder="Net Setelah Diskon"
                                value={nominalDisc}
                                onChange={event => handleNominalDisc(event)}
                                onFocus={event => setFocus("nominalDisc")}
                                InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}}
                                
                            /></Grid>
                            <Grid item xs={2}><NumberFormat customInput={TextField} 
                                variant="outlined"
                                thousandSeparator={true}
                                suffix={'%'}
                                value={DiscPercent}
                                onFocus={event => setFocus("DiscPercent")}
                                onChange={event => handleDiscPercent(event)}
                                autoComplete="off"/></Grid>

                              <Grid item xs={7}><Typography variant="h6">Sub Total Setelah Discount:</Typography></Grid>
                              <Grid item xs={5}><TextField
                                name="Net Setelah Diskon"
                                placeholder="Net Setelah Diskon"
                                value={subDiskon}
                                onFocus={event => setFocus("subDiskon")}
                                onChange={event => handleSubDiskon(event)}
                                InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}}
                                
                              /></Grid>
                              <Grid item xs={7}><Typography variant="h6">Grand Total Setelah Discount:</Typography></Grid>
                              <Grid item xs={5}><TextField
                                name="Net Setelah Diskon"
                                placeholder="Net Setelah Diskon"
                                value={grandDiskon}
                                onFocus={event => setFocus("grandDiskon")}
                                onChange={event => handleGrandDiskon(event)}
                                InputProps={{inputComponent: NumberFormatCustom, style:{fontWeight: 'bold', fonrSize:"16px"}}}
                                
                              /></Grid>
                            </Grid>
                            
                            
                            )}
                            
                            

      <Grid md={6}>
        <Button sx={{ mt: 5 }} onClick={() => props.prevButton()} size="medium" type="button" variant="contained">Previous</Button>
      </Grid>
      <Grid container md={6} justifyContent="flex-end">
      <Button sx={{ mt: 5 }} 
  onClick={async () => {
    if(props.companyID){
    if (
      alamatKontrak && 
      durasiKontrak &&
      selectedPaketVO &&
      kontrakSub &&
      kontrakGrand &&
      ppnPercent &&
      discStatus
    ) {
      const client = await getClient();
      const company = await getCompany();
      props.nextButton({
        ...props.selectedPost, 
        selectedPackage, 
        packageTitle: getSelectedPackageTitle(), 
        Lokasi:alamatKontrak,
        address2: address2,
        address3: address3,
        phone: phone, 
        durasiKontrak:durasiKontrak, 
        unitDurasi:unitDurasiKontrak, 
        namaPaket:selectedPaketVO, 
        durasiMeeting:durasiMeetingKontrak, 
        unitMeetingKontrak: unitMeetingKontrak, 
        tanggalAwal:paidDate, 
        tanggalAkhir:getTanggalAkhir(), 
        subTotalKontrak:kontrakSub, 
        grandTotalKontrak:kontrakGrand, 
        ppnPercent: ppnPercent, 
        ppnKontrak:kontrakPPN, 
        discStatus:discStatus,
        grandDiskon:grandDiskon,
        client: client,
        company: company 
      });
    } else {
      console.log("Please fill all required fields.");
    }}else{
      ///noCompany
      if (
      alamatKontrak && 
      durasiKontrak &&
      selectedPaketVO &&
      kontrakSub &&
      kontrakGrand &&
      ppnPercent &&
      discStatus
    ) {
      const client = await getClient();
      props.nextButton({
        ...props.selectedPost, 
        selectedPackage, 
        packageTitle: getSelectedPackageTitle(), 
        Lokasi:alamatKontrak,
        address2: address2,
        address3: address3,
        phone: phone, 
        lokasiSingkatan:lokasiSingkatan,
        durasiKontrak:durasiKontrak, 
        unitDurasi:unitDurasiKontrak, 
        namaPaket:selectedPaketVO, 
        durasiMeeting:durasiMeetingKontrak, 
        unitMeetingKontrak: unitMeetingKontrak, 
        tanggalAwal:paidDate, 
        tanggalAkhir:getTanggalAkhir(), 
        subTotalKontrak:kontrakSub, 
        grandTotalKontrak:kontrakGrand, 
        ppnPercent: ppnPercent, 
        ppnKontrak:kontrakPPN, 
        discStatus:discStatus,
        grandDiskon:grandDiskon,
        client: client,
      });
    } else {
      console.log("Please fill all required fields.");
    }

    }
  }} 
  size="medium" 
  type="button" 
  variant="contained">
  Next
</Button>      </Grid>
    </Grid>);};

    export default Step4;
